import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import style from './style.css';
import classNames from 'classnames';

const ConfigKeyList = ({ keys, currentKey, activeKey, activeDate, onKeyChange, isChangingKey }) => {
  return (
    <ol className={ style.list }>
      { keys
        .sort((a, b) => {
          if (a.value < b.value) return 1;
          if (a.value > b.value) return -1;
          return 0;
        })
        .map(({ value, isSaved}, index) =>
          <li
            key={ index }
            value={ value }
            className={ classNames(style.item, {
              [style.selected]: value === currentKey,
              [style.unsaved]: !isSaved,
            }) }
          >
            <input
              className={ style.check }
              type="radio"
              name="active"
              value={ value }
              checked={ value === activeKey }
              onChange={ onKeyChange }
              disabled={ isChangingKey }
            />
            <Link className={ style.link }to={`/redigera/${value}` }>
              { value }
              { activeDate && value === activeKey
                ? <span className={ style.activeDate }>{` Utskick ${ activeDate}`}</span>
                : null
              }
            </Link>
          </li>
        )}
    </ol>
  );
};

ConfigKeyList.propTypes = {
  keys: PropTypes.array.isRequired,
  onKeyChange: PropTypes.func.isRequired,
  isChangingKey: PropTypes.bool.isRequired,
  currentKey: PropTypes.string,
  activeKey: PropTypes.string,
  activeDate: PropTypes.string,
};

export default ConfigKeyList;



// WEBPACK FOOTER //
// ./client/src/components/config-key-list/index.js